import React from "react";
import DataTable from "../components/DataTable";

const ContentClicks = ({ data, getFreeData }) => {
  let tableData = [];

  if (data && Object.keys(data).length > 0) {
    tableData.push({
      ...data,
      title: "TOTAL CONTENT CLICKS",
    });
  }
  return (
    <div className="main-div h-auto" style={{ marginTop: "10px" }}>
      <div className="heading">
        <div className="title">
          <h6 className="fw600">Content Clicks</h6>
        </div>
      </div>
      <DataTable tableData={tableData} getFreeData={getFreeData} />
    </div>
  );
};

export default ContentClicks;
